import PropTypes from 'prop-types'
import React, { Component } from 'react'

import IndexList from '../../shared/components/IndexList'
import ColumnList from '../../shared/components/ColumnList'
import ListEntry from './ListEntry'

import { deepGet } from '../../shared/utils'

export default class List extends Component {

  static propTypes = {
    auth: PropTypes.object,
    store: PropTypes.object,
  }

  renderEntry(props) {
    const { entry, ...rest } = props
    return (
      <ListEntry
        museum={entry}
        {...rest}
      />
    )
  }

  render() {

    const { store, auth } = this.props
    const currentUserMuseum = deepGet(auth, 'user.museumId')

    return (
      <div className="app-pane pane column-xl">
        <div
          className="vertical"
        >
          <h1>Alle Museen</h1>

          <IndexList
            list={store.collection}
            keyString="sanitizedOrderName"
            className="museum-initials"
          />

          <ColumnList
            list={store.collection}
            currentUserMuseum={currentUserMuseum}
            keyString="sanitizedOrderName"
            className="museum-list"
            renderEntry={this.renderEntry}
            isMuseum
          />

        </div>
      </div>
    )

  }

}



// WEBPACK FOOTER //
// ./src/museum/components/List.js